export default "__VITE_ASSET__7498c979__"